import React from 'react';
import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';
import type { TaskStatus } from '../../types/tasks';

interface StatusBadgeProps {
  status: TaskStatus;
  className?: string;
}

const statusConfig: Record<TaskStatus, { label: string; className: string }> = {
  Todo: {
    label: 'To Do',
    className: 'border-transparent bg-slate-100 text-slate-700 dark:bg-slate-800/30 dark:text-slate-400',
  },
  InProgress: {
    label: 'In Progress',
    className: 'border-transparent bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  },
  InReview: {
    label: 'In Review',
    className: 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
  },
  Done: {
    label: 'Done',
    className: 'border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
  },
};

export const statusLabel: Record<TaskStatus, string> = {
  Todo: 'To Do',
  InProgress: 'In Progress',
  InReview: 'In Review',
  Done: 'Done',
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const config = statusConfig[status];
  return (
    <Badge className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
